module.exports = __webpack_public_path__ + "static/media/final-01.cf8ccd92.svg";